window.getFormattedDate = function(dateStr, defResult) {
    if (dateStr){
        return Date.create(dateStr).format('DD/MM/YYYY HH:mm')
    }
    return defResult
}

window.getTooltipDate = function (dateStr) {
    if (dateStr){
        return Date.create(dateStr).format("DD/MM/YYYY - HH:mmZ")
    }
    return ''
}
